import { useDocumentSelfAssessment } from "~/stores/document-self-assessment/useDocumentSelfAssessment";

export const useDocumentSelfAssessmentStore = (documentId: string) => {
  return useDocumentSelfAssessment(documentId)();
};
